export default {
    TextMessage: 'TextMessage',
    ImageMessage: 'ImageMessage',
    DiscussionNotificationMessage: 'DiscussionNotificationMessage',
    VoiceMessage: 'VoiceMessage',
    RichContentMessage: 'RichContentMessage',
    HandshakeMessage: 'HandshakeMessage',
    UnknownMessage: 'UnknownMessage',
    LocationMessage: 'LocationMessage',
    InformationNotificationMessage: 'InformationNotificationMessage',
    ContactNotificationMessage: 'ContactNotificationMessage',
    ProfileNotificationMessage: 'ProfileNotificationMessage',
    CommandNotificationMessage: 'CommandNotificationMessage',
    CommandMessage: 'CommandMessage',
    TypingStatusMessage: 'TypingStatusMessage',
    ChangeModeResponseMessage: 'ChangeModeResponseMessage',
    ChangeModeMessage: 'ChangeModeMessage',
    EvaluateMessage: 'EvaluateMessage',
    HandShakeMessage: 'HandShakeMessage',
    HandShakeResponseMessage: 'HandShakeResponseMessage',
    SuspendMessage: 'SuspendMessage',
    TerminateMessage: 'TerminateMessage',
    CustomerContact: 'CustomerContact',
    CustomerStatusUpdateMessage: 'CustomerStatusUpdateMessage',
    SyncReadStatusMessage: 'SyncReadStatusMessage',
    ReadReceiptRequestMessage: 'ReadReceiptRequestMessage',
    ReadReceiptResponseMessage: 'ReadReceiptResponseMessage',
    FileMessage: 'FileMessage',
    AcceptMessage: 'AcceptMessage',
    RingingMessage: 'RingingMessage',
    SummaryMessage: 'SummaryMessage',
    HungupMessage: 'HungupMessage',
    InviteMessage: 'InviteMessage',
    MediaModifyMessage: 'MediaModifyMessage',
    MemberModifyMessage: 'MemberModifyMessage',
    JrmfReadPacketMessage: 'JrmfReadPacketMessage',
    JrmfReadPacketOpenedMessage: 'JrmfReadPacketOpenedMessage',
    ReferenceMessage: 'ReferenceMessage',
};
